import { Box, Spinner, StackLayout, StackLayoutItem, Text } from '@auth0/quantum-product';
import * as React from 'react';
import { useTranslation } from '../hooks/useTranslation';
export var LoadingPage = function () {
    var t = useTranslation('core').t;
    return (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 },
        React.createElement(StackLayout, null,
            React.createElement(StackLayoutItem, null,
                React.createElement(Text, { variant: "h5" }, t('pages.loading.loadingText'))),
            React.createElement(StackLayoutItem, null,
                React.createElement(Spinner, null)))));
};
